import { render, staticRenderFns } from "./insurer-plans.vue?vue&type=template&id=b9d21dcc&scoped=true&"
import script from "./insurer-plans.vue?vue&type=script&lang=js&"
export * from "./insurer-plans.vue?vue&type=script&lang=js&"
import style0 from "./insurer-plans.vue?vue&type=style&index=0&id=b9d21dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d21dcc",
  null
  
)

export default component.exports